import React from 'react'
import Layout from '../components/Layout';
import { graphql, Link } from 'gatsby';
import { useMediaQuery } from '../hooks/useMediaQuery';
import { FaqPageTemplate } from './faq-page';
import SanitizeHTML from '../components/SanitizeHTML';
import ReactMarkdown from 'react-markdown'
import SignupButton from '../components/SignupButton';
import HowItWorks from '../components/HowItWorks';

export const IndexPageTemplate = (props) => {
  const isDesktop = useMediaQuery('(min-width: 900px)');
  const { frontpage } = props;

  const faq = {
    ...props.faq,
    questions: props.faq.questions.filter(f => f?.onFrontpage === true)
  };

  return <>
    <Layout isLandingPage={true}>

      <div className="primary-panel">
        <div className="layer">
          <div className="full">
            <div className="all-center hero-text">
              <div className="cent-text">
                <div style={{ textAlign: 'center', border: '0px solid red' }}>
                  {isDesktop && <div style={{ height: '100px' }}>&nbsp;</div>}
                  <h4 style={{ border: '0px solid blue' }}>
                    {frontpage.tagline}
                  </h4>
                </div>
                <div >
                  <div className="fp-card2">
                    <SanitizeHTML html={frontpage.subTagline} />
                    <div style={{ height: '40px' }}></div>
                    <Link to="/flytjendur-og-utgefendur">
                      <button className="btn btn-big btn-outlined more-info">Nánari upplýsingar</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <h1>
          Um SFH
        </h1>

        <ReactMarkdown>
          {frontpage.aboutSFH}
        </ReactMarkdown>

        <div>
          <h5>Hvernig virkar úthlutunarferlið?</h5>

          <HowItWorks />

        </div>
      </div>

      <div className="container alt-bg">
        <FaqPageTemplate questions={faq} />
      </div>

      <div className="container">
        <h1>Skráning í SFH</h1>
        <ReactMarkdown>
          {frontpage.signupText}
        </ReactMarkdown>

        <SignupButton />
      </div>

<div className="container alt-bg">
  <h4>Tilkynning</h4>

  <p>
    Til aðila innan SFH: Rétt er að vekja athygli á að mánudaginn 11. maí
    n.k. kl. 15.00 verður að Rauðagerði 27, Reykjavík haldinn aðalfundur
    SFH. Á dagskrá eru venjubundin aðalfundarstörf og þar verður m.a.
    lögð fram eftirfarandi tillaga um stefnur SFH.
  </p>

  <details>
    <summary>
      <span className="btn btn-outlined" style={{ marginBottom: 20 }}>
        Nánar...
      </span>
    </summary>

    <p>Ýmsar stefnur SFH sem lagðar verða fram til samþykktar á aðalfundi samtakanna þann 11. maí 2026</p>

    <p>Lagt er til að eftirfarandi stefnur SFH verði samþykktar á aðalfundi SFH þann 11. maí 2026. Stefnur þessar eru í samræmi við ákvæði umsýslulaga nr. 88/2019.</p>

    <p><strong>Almenn stefna um úthlutun réttindagreiðslna til rétthafa</strong><br />
    SFH úthlutar þóknunum á grundvelli 47. greinar höfundalaga annars vegar vegna notkunar útvarps- og sjónvarpsstöðva á útgefnum hljóðritum með tónlist og hins vegar spilunar tónlistar af hljóðritum á opinberum stöðum svosem verslunum, veitingastöðum og líkamsræktarstöðvum.</p>

    <p><strong>Almenn fjárfestingarstefna</strong><br />
    Stjórn skal ávaxta fjármuni félagsins með tryggum hætti, einkum með vörslu á innlánsreikningum banka. Leitast skal við að ávaxta fjármuni félagsins með sem arðbærustum hætti.</p>

    <p><strong>Almenn stefna um frádrátt frá réttindatekjum og arðs af fjárfestingu þeirra</strong><br />
    Áður en ákvörðun um úthlutun á réttindagreiðslum er tekin, skal stjórn draga frá tekjum öll rekstrargjöld og önnur útgjöld SFH auk framlags til stuðningssjóðs. Miða skal við fjárhæðir í samþykktum eins og þær koma fram í ársreikningi SFH á hverju rekstrarári. Leitast skal við að halda rekstrarkostnaði í lágmarki, án þess þó að það bitni á starfsemi félagsins. Stjórn er heimilt að setja sérreglur um mismunandi skiptingu á gjöldum til frádráttar af réttindagreiðslum eftir eðli þeirra.<br />
    Fjármagnstekjum skal ráðstafað við úthlutun til rétthafa með sama hætti og öðrum tekjum.</p>

    <p><strong>Notkun óráðstafanlegra fjárhæða</strong><br />
    Ef rétthafi finnst ekki eða gerir ekki kröfu til áunninna réttinda, þegar 3 ár eru liðin frá þeim áramótum er rétthafi gat krafist úthlutunar hjá SFH eða IHM eða öðrum sambærilegum aðilum, er viðkomandi fjármunum ráðstafað aftur til úthlutunar og getur hvor deild (flytjendur eða framleiðendur) ákveðið hvernig þeim fjármunum verður úthlutað.<br />
    Til frekari skýringa er vísað til ákvæða úthlutunarreglna SFH á heimasíðu samtakanna.</p>

    <p><strong>Áhættustýringarstefna</strong><br />
    Stjórn SFH leitast ávallt við að lágmarka áhættu við starfsemi SFH. Er það m.a. gert með því að ávaxta fé samtakanna með öruggum hætti eins og fram kemur í almennri fjárfestingarstefnu samtakanna.</p>

    <p>Verði framangreindar stefnur samþykktar munu þær gilda áfram þar til þeim, einni eða fleiri, verði breytt á aðalfundi SFH.</p>
  </details>
</div>

    </Layout>
  </>
}


const IndexPage = (props) => {
  const faq = props.data.faq.frontmatter;
  const frontpage = props.data.frontpage.frontmatter;

  return <IndexPageTemplate
    faq={faq}
    frontpage={frontpage}
  />
}

export default IndexPage;

export const indexQuery = graphql`
  query IndexQuery {
    frontpage: markdownRemark(frontmatter: {templateKey: {eq: "index-page"}}) {
      frontmatter {
        title
        tagline
        subTagline
        aboutSFH
        signupText
      }
    }
    faq: markdownRemark(frontmatter: {templateKey: {eq: "faq-page"}}) {
      frontmatter {
        title
        questions {
          question
          answer
          onFrontpage
        }
      }
    }
  }
  `;
